import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { useBibliotecaContext } from "../../context/BibliotecaContext";

export function StateFilter() {
    const { t } = useTranslation();
    const { estadosData, estadosSelecionados, setEstadosSelecionados } = useBibliotecaContext();

    const options = estadosData
        ? estadosData.map((estado) => ({
            label: `${estado.nome} - ${estado.descricao}`,
            value: estado.areaatuacao_id,
        }))
        : [];

    const selectAllOption = { label: "Todos - Selecionar todos", value: "*" };
    const allOptions = [selectAllOption, ...options];

    let valueParaOSelect;
    if (estadosSelecionados.includes("*")) {
        valueParaOSelect = [selectAllOption];
    } else {
        valueParaOSelect = options.filter((option) =>
            estadosSelecionados.includes(option.value)
        );
    }

    const handleChange = (selected, actionMeta) => {
        if (actionMeta.action === "select-option" && actionMeta.option.value === "*") {
            setEstadosSelecionados(["*"]);
            return;
        }

        if (!selected) {
            setEstadosSelecionados([]);
            return;
        }

        const newSelection = selected
            .filter((o) => o.value !== "*")
            .map((o) => o.value);

        setEstadosSelecionados(newSelection);
    };

    return (
        <div className="mt-4">
            <div className="mb-2">{t("biblioteca.state")}</div>
            <Select
                value={valueParaOSelect}
                isMulti
                name="estados"
                options={allOptions}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={handleChange}
                placeholder={t("biblioteca.selectState")}
                noOptionsMessage={() => t("biblioteca.emptyState")}
            />
        </div>
    );
}